/**
 * Settings → Product & Services (/settings/product-services)
 *
 * Three tabs matching the legacy ProductServiceManagement module:
 *   1. Product Groups — searchable list with code/name/description/status/date
 *   2. Products — grouped tree (group › main products + add-ons), price model, price, status
 *   3. VAT Rates — grouped tree (group › rates), tax %, effective range, status
 *
 * Nav entry: settings-product-service → /settings/product-services (already in nav.ts).
 */
import { Container, PageHeader } from '@vnetwork/ui/layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@vnetwork/ui/primitives';
import { Boxes, Package, Receipt } from 'lucide-react';
import { ProductGroupsTab } from './product-groups-tab';
import { ProductsTab } from './products-tab';
import { VatRatesTab } from './vat-rates-tab';

export default function ProductServicesPage() {
  return (
    <Container size="full">
      <div style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        <PageHeader
          title="Product & Services"
          description="Manage product groups, products, and VAT rates."
        />

        <Tabs defaultValue="product-groups">
          <TabsList>
            <TabsTrigger value="product-groups">
              <Boxes size={15} style={{ marginRight: 'var(--vn-space-2)' }} />
              Product Groups
            </TabsTrigger>
            <TabsTrigger value="products">
              <Package size={15} style={{ marginRight: 'var(--vn-space-2)' }} />
              Products
            </TabsTrigger>
            <TabsTrigger value="vat-rates">
              <Receipt size={15} style={{ marginRight: 'var(--vn-space-2)' }} />
              VAT Rates
            </TabsTrigger>
          </TabsList>

          <TabsContent value="product-groups" style={{ marginTop: 'var(--vn-space-4)' }}>
            <ProductGroupsTab />
          </TabsContent>

          <TabsContent value="products" style={{ marginTop: 'var(--vn-space-4)' }}>
            <ProductsTab />
          </TabsContent>

          <TabsContent value="vat-rates" style={{ marginTop: 'var(--vn-space-4)' }}>
            <VatRatesTab />
          </TabsContent>
        </Tabs>
      </div>
    </Container>
  );
}
